module.exports = __webpack_public_path__ + "static/media/price-img1.eb99cdf7.webp";